import { Route, Routes } from 'react-router-dom';

import InvoiceList from '../components/Invoices/InvoiceList';
import EditInvoice from '../components/Invoices/EditInvoice';
import ViewInvoice from '../components/Invoices/ViewInvoice';

const Invoices = () => {
  return (
    <Routes>
      <Route path="/" element={<InvoiceList />} />
      <Route path="/edit/:id" element={<EditInvoice key="edit" />} />
      <Route path="/edit" element={<EditInvoice key="add" />} />
      <Route path="/view/:id" element={<ViewInvoice />} />
    </Routes>
  )
}

export default Invoices;